import {useState} from 'react';
import {message} from 'antd';
import {t} from 'i18next';
import {formatDate, http} from '@/utils';
import {FormatDateEnum} from '@/models';

export interface IUseExportDateParams {
  withDate: boolean;
  url: string;
  startDate?: Date;
  endDate?: Date;
  data?: string;
  withContactData: boolean;
  from?: string;
  to?: string;
  role?: string;
  roleType?: string;
  onSuccess: () => void;
}

const useExportData = () => {
  const [isLoading, setIsLoading] = useState(false);

  const sendExportRequest = async ({
                                     from,
                                     to,
                                     withDate,
                                     startDate,
                                     endDate,
                                     role,
                                     url,
                                     data,
                                     withContactData,
                                     roleType,
                                     onSuccess,
                                   }: IUseExportDateParams) => {
    try {
      setIsLoading(true);
      let finalUrl = `${process.env.REACT_APP_EXPORT}/${url}${
        withContactData ? `${!url?.includes('?') ? '?' : ''}isDetailed=true` : ''
      }`;
      if (withDate) {
        const startDateVal = formatDate(startDate, FormatDateEnum.YMDEXPORT);
        const endDateVal = formatDate(endDate, FormatDateEnum.YMDEXPORT);
        finalUrl = `${process.env.REACT_APP_EXPORT}/${url}?${from}=${startDateVal}&${to}=${endDateVal}${
          withContactData ? `&${data}=true` : `&${data}=false`
        }${role ? `&${role}=${roleType}` : ''}`;
      }
      const response = await http.get(finalUrl);
      const responseMessage =
        response?.data?.data?.message ?? (url === 'export/gift-cards-report' || url === 'export/sessions-report')
          ? t('exportSuccessToSlackMsg')
          : t('exportSuccessMsg');
      message.success(responseMessage);
      onSuccess?.();
    } catch (error) {
      const errorMessage = error?.response?.data?.feedback?.message ?? t('exportFailureMsg');
      message.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    sendExportRequest,
  };
};

export default useExportData;
